import { render, staticRenderFns } from "./GroupedProductSelector.vue?vue&type=template&id=0918f7cf&"
import script from "./GroupedProductSelector.vue?vue&type=script&lang=ts&"
export * from "./GroupedProductSelector.vue?vue&type=script&lang=ts&"
import style0 from "./GroupedProductSelector.vue?vue&type=style&index=0&id=0918f7cf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports